<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="update()">
                <div class="modal-header p-3">

                    <div>

                        <h5 class="mb-0">Editar Valor do Módulo</h5>
                        <small>{{ moduloEdit.nome }}</small>

                    </div>
                    
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">
                    
                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Valor por usuário *" 
                            type="text" 
                            placeHolder="Digite aqui o valor de contratação desse módulo ..."
                            v-model="moduloEdit.valor"
                            maskType="money"
                            />
                        </div>

                    </div>

                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Salvar" type="success" :submit="true" :isLoading="isLoading" :loadingText="'Atualizando Módulo'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useModulosStore } from '@/stores/modulos';
    import { toast } from 'vue3-toastify'

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
            modulo: {
                type: Object
            }
        },
        emits:['close'],
        data(){
            return{
                isLoading: false,
                moduloEdit: {},
                modulosStore: useModulosStore(),
            }
        },
        methods:{
            closeModal(){
                this.$emit('close');
            },
            async update(){

                this.isLoading = true
                
                let valor = this.moduloEdit.valor
                if(typeof valor == 'string'){
                    valor = valor.replace('R$ ','')
                    valor = valor.replace('.','')
                    valor = valor.replace(',','.')
                    valor = parseFloat(valor)
                }

                const result = await this.modulosStore.update(this.moduloEdit.id, valor)
                this.isLoading = false

                if(result.status){
                    toast.success("Módulo editado com sucesso")
                    this.closeModal()
                    this.modulosStore.get()
                }else{
                    toast.error(result.message)
                }

            },
            getParcerias(){
                const parcerias = this.parceriasStore.parcerias.filter(p => p.id != '')
                parcerias.unshift({id:'',nome:'Nenhuma'})
                return parcerias
            }
        },
        watch:{
            'modulo' : {
                handler(moduloNew){
                    this.moduloEdit = { ...moduloNew }

                    if(this.moduloEdit.valor){
                        this.moduloEdit.valor = this.moduloEdit.valor.toString()
                        if(!this.moduloEdit.valor.includes('.')) this.moduloEdit.valor = parseFloat(this.moduloEdit.valor).toFixed(2).replace('.',',')
                        else{
                            this.moduloEdit.valor = this.moduloEdit.valor.replace('.',',')
                        }
                    }

                },
                immediate: true
            }
        },
        mounted() {
        }
    }
</script>